import {
    cancelFlow_offerResultClick,
    cancelFlow_offerResultScreenLoad,
    OfferTypes,
} from 'analytics/trackers/cancelFlow';
import { pauseFlow_pauseResultClick, pauseFlow_pauseResultScreenLoad } from 'analytics/trackers/pauseFlow';

import { PaymentMethods } from 'constants/payment';
import { DAYS_PER_YEAR } from 'constants/periods';
import { PRODUCT_IDS_WITH_LOW_PRICES_FOR_AQA } from 'constants/product';

import { isMainSubscription } from 'helpers/subscriptions';

import { CancellationFlow } from 'components/Modals/CancellationReasonModal/types';

import { SubscriptionProductCodeTypes } from 'types/product';
import { ISubscription, PaymentProviders } from 'types/subscription';

export const isPauseFlow = ({
    flow,
    productCodeType,
    wasPaused,
}: {
    flow: string;
    productCodeType: SubscriptionProductCodeTypes;
    wasPaused: boolean;
}) => {
    if (wasPaused) return false;

    const isPauseSubscriptionFlow = flow === CancellationFlow.withPauseSubscription;
    const isMainPlanSubscription = isMainSubscription(productCodeType);

    return isPauseSubscriptionFlow && isMainPlanSubscription;
};

export const isOneYearSubscription = (period: number): boolean => {
    return period === DAYS_PER_YEAR;
};

export const checkIsProductIdWithTestPrice = (productId: string): boolean => {
    return PRODUCT_IDS_WITH_LOW_PRICES_FOR_AQA.includes(productId);
};

export const checkIsPaymentFormNeeded = (candidate: ISubscription) => {
    return (
        candidate.payment_provider === PaymentProviders.Solidgate &&
        [PaymentMethods.google_pay, PaymentMethods.apple_pay].includes(candidate.payment_method)
    );
};

export type EventClickType = {
    isPauseFlow?: boolean;
    action: 'continue' | 'close' | 'try_again' | 'contact_support' | 'got_it';
    result: 'success' | 'fail';
    offer_type?: OfferTypes;
    subscription_id: string;
};

export const trackResultClickEvent = ({ action, result, offer_type, subscription_id, isPauseFlow }: EventClickType) => {
    if (isPauseFlow) {
        pauseFlow_pauseResultClick({ action, result, subscription_id });
        
return;
    }

    if (offer_type) {
        cancelFlow_offerResultClick({ action, result, offer_type, subscription_id });
    }
};

export const trackResultScreenLoadEvent = ({
    result,
    offer_type,
    subscription_id,
    isPauseFlow,
}: {
    result: 'success' | 'fail';
    subscription_id: string;
    offer_type?: OfferTypes;
    isPauseFlow?: boolean;
}) => {
    if (isPauseFlow) {
        pauseFlow_pauseResultScreenLoad({
            result,
            subscription_id,
        });
        
return;
    }

    if (offer_type) {
        cancelFlow_offerResultScreenLoad({
            result,
            offer_type,
            subscription_id,
        });
    }
};
